import React from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Alert, Button, Collapse } from "@mui/material";

import { removeUser } from "store/authSlice";
import { baseApi } from "store/services/baseApi";

const ErrorAlert = ({ error = null }) => {
  const dispatch = useDispatch();

  const navigate = useNavigate();
  // methods
  const reLoginUser = () => {
    dispatch(removeUser());
    dispatch(baseApi.util.resetApiState());
    navigate("/sign-in");
  };

  return (
    <Collapse in={!!error}>
      <Alert
        severity="error"
        action={
          error?.status === 401 && (
            <Button size="small" onClick={reLoginUser}>
              Re-Login
            </Button>
          )
        }
      >
        {error?.data?.message ??
          error?.message ??
          "OOPS! Something went wrong!"}
      </Alert>
    </Collapse>
  );
};

export default ErrorAlert;
